import { useEffect, useState } from 'react'

/**
 * Handles input value change with debouncing.
 * @constructor
 * @param {string} value - The input event to handle.
 * @param {number} delay - The delay to update input value in ms.
 */

export const useDebouncedInput = (value: string, delay: number) => {
  const [debouncedValue, setDebouncedValue] = useState(value)

  useEffect(() => {
    // Set debouncedValue to value after the specified delay
    const handler = setTimeout(() => {
      setDebouncedValue(value)
    }, delay)
    return () => {
      clearTimeout(handler)
    }
  }, [value, delay])

  return debouncedValue
}
